import React, { useContext } from "react"
import tw, { styled } from "twin.macro"
import { useLocation } from "@reach/router"

import MenuItem from "components/header/menu-item"
import LinkTo from "components/link-to"
import { brandRules } from "utils/brand"
import ActiveRouteContext from "context/active-route-context"

const MenuItemLink = ({ linkInfo, title, className }) => {
  const { section } = useContext(ActiveRouteContext)

  const location = useLocation()

  const { url } = linkInfo

  // never highlight content valuation in products section as it is a first class citizen in the menu
  const isActive =
    (url.endsWith(section) || location.pathname.endsWith(url)) &&
    !url.startsWith("products/streaming-economics")

  return (
    <LinkTo linkInfo={linkInfo}>
      <MenuItem
        dangerouslySetInnerHTML={{ __html: brandRules(title) }}
        className={`${className} ${isActive ? "active" : ""}`}
      />
    </LinkTo>
  )
}

const IndustriesMenuItems = ({ industries, className }) => (
  <>
    {industries.map(({ node: industry }) => (
      <MenuItemLink
        linkInfo={{
          url: `/industry/${industry.slug}`,
          isExternal: false,
          openInNewTab: false,
        }}
        title={industry.title}
        key={industry.id}
        className={className}
      />
    ))}
  </>
)

const ApplicationsMenuItems = ({ applications, className }) => (
  <>
    {applications.map(({ node: app }) => (
      <MenuItemLink
        linkInfo={{
          url: `/solutions#${app.slug}`,
          isExternal: false,
          openInNewTab: false,
        }}
        title={app.title}
        key={app.id}
        className={className}
      />
    ))}
  </>
)

const ManualMenuItems = ({ menuItems, className }) => (
  <>
    {menuItems.map((menuItem) => (
      <MenuItemLink
        linkInfo={menuItem}
        title={menuItem.title}
        key={menuItem.id}
        className={className}
      />
    ))}
  </>
)

const MenuItems = ({ menu, applications, industries, className }) => {
  switch (menu.menuItemsSource) {
    case "industries":
      return (
        <IndustriesMenuItems
          className={className}
          industries={industries}
        ></IndustriesMenuItems>
      )
    case "applications":
      return (
        <ApplicationsMenuItems
          className={className}
          applications={applications}
        ></ApplicationsMenuItems>
      )
    case "manual":
      return (
        <ManualMenuItems
          className={className}
          menuItems={menu.menuItems}
        ></ManualMenuItems>
      )
  }
}

export default MenuItems
